<div
	[editableInStoryblok]="_editable"
	[ngClass]="{ 'h-full': !stopGrow() }"
	class="w-full"
>
	@if (components && headingInputs()?.[0]) {
		@let heading = headingInputs()[0];
		@let button = buttons()[0];

		<vp-persuade-card
			[ctaText]="button?.text"
			[ctaType]="'btn-' + button?.type"
			[ctaUrl]="button?.link.cached_url"
			[headingType]="heading?.headingType"
			[images]="flatImages()"
			[linkListConfig]="linkList()"
			[overline]="heading?.overline"
			[title]="heading?.title"
			[useVerticalCard]="!isHorizontal()"
			imageVariant="grid"
		>
			<ng-container content>
				@for (blok of contentInputs(); track $index) {
					<ndc-dynamic
						[ndcDynamicComponent]="components[blok['component']]"
						[ndcDynamicInputs]="blok"
						class="hidden"
					/>
				}
			</ng-container>
		</vp-persuade-card>
	}
</div>
